// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../../graphql/api/index';

import { MonolithImageSizeFragmentDoc } from '../../components/monolithImageSize.fragment.generated';
export const NonSkuLabGrownStoneImageFragmentDoc = `
    fragment nonSkuLabGrownStoneImage on NonSkuLabGrown {
  image {
    __typename
    id
    url
    sizes(names: [W250, W320, W480, W640, W768, W1024]) {
      ...monolithImageSize
    }
  }
  shapeDimension {
    __typename
    id
    image {
      __typename
      id
      url
      sizes(names: [W250, W320, W480, W640, W768, W1024]) {
        ...monolithImageSize
      }
    }
    shape {
      __typename
      systemCode
      samplePhoto {
        __typename
        id
        url
        sizes(names: [W250, W320, W480, W640, W768, W1024]) {
          ...monolithImageSize
        }
      }
    }
  }
}
    `;